import { ImpactOrderReportPeriod, ImpactType } from "@ecologi/shared";
import { DateTime } from "luxon";
import { fetchFromAPI } from "./fetch-from-api";

export const getApiHistoryForYear = async (
  year: string
): Promise<{ periods: ImpactOrderReportPeriod[] }> => {
  const start = DateTime.fromISO(year).startOf("year").toSeconds();
  const end = DateTime.fromISO(year).endOf("year").toSeconds();

  const urlSearchParams = new URLSearchParams({
    start: start.toString(),
    end: end.toString(),
    variant: "API",
    period: "month",
  });
  return fetchFromAPI(`/impact-order-reports?${urlSearchParams.toString()}`);
};

export const getPendingImpactTotals = async (
  userId: string
): Promise<Record<ImpactType, number>> => {
  return fetchFromAPI(`/impact-order-reports/pending-impact-totals/${userId}`);
};
